<template>
  <div>
    <loading-spinner v-if="isLoading" :status="$t('functional.authenticating')"></loading-spinner>
    <!-- <div class="loader" v-if="isLoading">
      <div class="loader__icon"></div>
    </div> -->
    <div id="app" v-else-if="!showEnvelopeComplete">
      <router-view></router-view>
    </div>
    <div v-else-if="showEnvelopeComplete">
      <envelope-complete
        :status="envelopeStatus"
        :clientId="clientId"
        :companyName="companyName"
        :requestedEnvelope="requestedEnvelope"></envelope-complete>
    </div>
  </div>
</template>

<script>
import EnvelopeComplete from '@/components/EnvelopeComplete'
import LoadingSpinner from '@/components/LoadingSpinner.vue'

import axios from 'axios'

export default {
  name: 'app',
  components: {
    EnvelopeComplete,
    LoadingSpinner
  },
  data () {
    return {
      scrollTop: 0,
      envelopeStatus: null,
      isSigned: false,
      clientId: null,
      companyName: null,
      showModalButtons: true,
      errorMessage: null,
      passwordStatus: {
        refresh: 1,
        required: false,
        title: null,
        password: null
      }
    }
  },
  beforeCreate () {
    this.requestedEnvelope = {
      envelopeFingerprint: this.$route.params.envelopeFingerprint,
      widgetCode: this.$route.params.widgetCode
    }

    this.$store.commit('setRequestedEnvelope', this.requestedEnvelope)

    axios.defaults.baseURL = process.env.VUE_APP_API_URL
  },
  // created () { // TODO Remove later, temporarily kept for reference
  //   // if (window.location.hash && window.location.hash.startsWith('/') && window.location.pathname === '/') { // TEMP Detect if hash mode style route has been provided and redirect accordingly
  //   //   const path = window.location.hash.slice(1, window.location.hash.length) // Removes hash from start of hash fragment
  //   //   this.$router.push({ path, hash: null }) // Navigate to path as derived from hash fragment
  //   // } else {
  //   //   this.getEnvelope()
  //   // }

  //   this.$bus.$on('nextDocument', () => { // TODO Make a watcher?
  //     const body = document.getElementsByTagName('body')[0]
  //     body.scrollTop = 0
  //     document.documentElement.scrollTop = 0
  //   })

  //   this.$bus.$on('loading', () => {
  //     this.isLoading = true
  //   })

  //   this.$bus.$on('loadingStop', () => {
  //     this.isLoading = false
  //   })

  //   this.$bus.$on('submitEnvelope', ({ response }) => {
  //     if (response.status === 'verify') {
  //       let redirectUrl = this.$store.getters.widgetRedirectUrl

  //       if (redirectUrl) {
  //         if (!redirectUrl.match(/^https:\/\/|^http:\/\//g)) redirectUrl = `http://${redirectUrl}` // Add http:// if not provided
  //         redirectUrl = new URL(redirectUrl) // Evaluate string as URL object

  //         window.location.replace(redirectUrl)
  //       } else {
  //         this.isSigned = true
  //         this.envelopeStatus = response.status
  //       }
  //     } else {
  //       this.$store.dispatch('getEnvelope', { query: this.$route.query, password: this.passwordStatus.password }).then((envelope) => {
  //         this.envelopeStatus = envelope.data.status

  //         if (response.status === 'rejected') { // TODO This needs to be more generic, isProcessed would be better
  //           this.isSigned = true
  //         } else if (response) {
  //           this.isSigned = response.status === 200
  //         } else {
  //           this.isSigned = true
  //         }

  //         this.isLoading = false
  //         if (envelope.data.envelope_redirect_url && response !== null) {
  //           window.location = envelope.data.envelope_redirect_url
  //         }
  //       })
  //     }
  //   })
  // },
  // mounted () {
  //   if (window.outerWidth <= 575) this.$store.commit('setMobile', { isMobile: true })

  //   window.addEventListener('scroll', (event) => {
  //     this.toggleDocumentNav(event)
  //     this.toggleProgressBar(event)
  //   })

  //   this.$bus.$on('scrollBody', () => {
  //     const header = document.querySelectorAll('header')
  //     const headerHeight = header[0].firstChild.clientHeight + 70
  //     const currentId = this.$store.state.activeFieldId
  //     const input = document.querySelectorAll(`.document-field[data-id="${currentId}"]`)
  //     if (input.length > 0) {
  //       const scrollAmount = this.getOffset(input[0])
  //       this.$SmoothScroll((scrollAmount - headerHeight), 500)
  //     }
  //   })
  // },
  computed: {
    isLoading () {
      return !this.$store.getters['auth/authAttempted'] && this.$route.meta.requiresAuth !== false
    },
    showEnvelopeComplete () { // TODO This will become a route in it own right
      return this.isSigned || ['cancelled', 'rejected', 'signed', 'expired'].indexOf(this.envelopeStatus) > -1
    }
  }
}
</script>

<style lang="sass">
  @import '@/styles/manifest.sass'
  #app
    position: relative

  .error-message
    text-align: center
</style>
